var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBot6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.50003,
    r: 9.5,
    fill: "#546EDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9412 8.02549V6.24998C12.9412 4.458 11.3974 3 9.50001 3C7.60259 3 6.05883 4.458 6.05883 6.25001V8.02552C5.4553 8.14151 5 8.64652 5 9.25001V13.75C5.00002 14.439 5.59348 15 6.32354 15H12.6765C13.4065 15 14 14.439 14 13.75V9.25001C14 8.64649 13.5447 8.14151 12.9412 8.02549ZM10.0871 11.865L10.2915 13.2145C10.3026 13.2865 10.2799 13.359 10.2296 13.4135C10.1793 13.468 10.1062 13.5 10.0294 13.5H8.97061C8.89385 13.5 8.82079 13.4685 8.77049 13.414C8.72019 13.3595 8.69743 13.2865 8.70855 13.215L8.91291 11.8655C8.47032 11.6565 8.17649 11.225 8.17649 10.75C8.17649 10.061 8.76997 9.50002 9.50001 9.50002C10.2301 9.50002 10.8235 10.061 10.8235 10.75C10.8235 11.225 10.5297 11.6565 10.0871 11.865ZM11.353 7.99999H7.64706V6.24998C7.64706 5.28499 8.47826 4.5 9.50001 4.5C10.5218 4.5 11.353 5.28499 11.353 6.25001V7.99999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot6);
export default __webpack_public_path__ + "static/media/bot6.419e9bf980b6cf89f6ffc368e4537592.svg";
export { ForwardRef as ReactComponent };